import { create } from "zustand";
import { persist } from "zustand/middleware";

export type CurrentUser = {
  id: number;
  email: string;
  name: string;
  role: "owner" | "staff" | "viewer";
  partner_id: number;
};

type AuthState = {
  token: string | null;
  user: CurrentUser | null;
  setSession: (token: string, user: CurrentUser) => void;
  logout: () => void;
};

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setSession: (token, user) => set({ token, user }),
      logout: () => set({ token: null, user: null }),
    }),
    { name: "partners-portal-auth" }
  )
);
